import { render } from "./HeaderTyreDetail.vue?vue&type=template&id=3f36894f"
import script from "./HeaderTyreDetail.vue?vue&type=script&lang=js"
export * from "./HeaderTyreDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__